// Realitní kancelář – Seznam poptávek (markup includes/template-parts/redesign/reality-office/poptavky/*.php).
// Bez JS funguje všechno (číselné pole Fluent Forms, řazení tlačítkem). JS přidává:
//  - k poli `rozpocet` tlačítka −/+ (krok jako budgetStep() v návrhu ř. 1063: pronájem 1 000 Kč, koupě
//    500 000 Kč, od 10 mil. 1 000 000 Kč) a předvolby z kolonek form.presets / presets_rent (data-presets),
//  - popisek rozpočtu podle „Hledám“ (pronajem → form.budget_label_rent, jinak form.budget_label),
//  - řazení seznamu ([data-ro-demand-sort]) se odešle samo po změně selectu.

const NAME_BUDGET = 'rozpocet';
const NAME_WANT = 'hledam';
const RENT = 'pronajem';

const parseJson = (text, fallback) => {
  try {
    return JSON.parse(text || '') ?? fallback;
  } catch (e) {
    return fallback;
  }
};

const budgetStep = (rent, value) => {
  if (rent) {
    return 1000;
  }
  return value >= 10000000 ? 1000000 : 500000;
};

function initBudget(root) {
  const input = root.querySelector(`input[name="${NAME_BUDGET}"]`);
  if (!input || input.dataset.roEnhanced) {
    return;
  }
  input.dataset.roEnhanced = '1';

  const form = input.form || root;
  const label = input.id ? root.querySelector(`label[for="${input.id}"]`) : null;
  const labels = { buy: root.dataset.labelBuy || '', rent: root.dataset.labelRent || '' };
  const presets = parseJson(root.dataset.presets, { buy: [], rent: [] });

  const isRent = () => {
    const checked = form.querySelector(`input[name="${NAME_WANT}"]:checked`);
    return !!checked && checked.value === RENT;
  };
  const value = () => {
    const n = parseInt(String(input.value).replace(/\D/g, ''), 10);
    return Number.isNaN(n) ? 0 : n;
  };

  // −  pole  +
  const stepper = document.createElement('div');
  stepper.className = 'ro-poptavky__stepper';
  const button = (text, aria) => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'ro-poptavky__step';
    b.textContent = text;
    b.setAttribute('aria-label', aria);
    return b;
  };
  const dec = button('−', 'Snížit');
  const inc = button('+', 'Zvýšit');
  input.parentNode.insertBefore(stepper, input);
  stepper.append(dec, input, inc);

  const chips = document.createElement('div');
  chips.className = 'ro-poptavky__presets';
  stepper.after(chips);

  const markPresets = () => {
    const current = value();
    chips.querySelectorAll('button').forEach((b) => {
      b.setAttribute('aria-pressed', String(parseInt(b.dataset.value, 10) === current));
    });
  };

  const set = (v) => {
    input.value = v > 0 ? String(v) : '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    markPresets();
  };

  const renderPresets = () => {
    const list = (isRent() ? presets.rent : presets.buy) || [];
    chips.replaceChildren(...list.map((p) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ro-poptavky__preset';
      b.dataset.value = String(p.value);
      b.textContent = p.label;
      b.addEventListener('click', () => set(p.value));
      return b;
    }));
    chips.hidden = list.length === 0;
    markPresets();
  };

  const syncWant = () => {
    const text = isRent() ? labels.rent : labels.buy;
    if (label && text) {
      label.textContent = text;
      label.setAttribute('aria-label', text);
    }
    renderPresets();
  };

  dec.addEventListener('click', () => set(Math.max(0, value() - budgetStep(isRent(), value()))));
  inc.addEventListener('click', () => set(value() + budgetStep(isRent(), value())));
  input.addEventListener('input', markPresets);
  form.querySelectorAll(`input[name="${NAME_WANT}"]`).forEach((r) => r.addEventListener('change', syncWant));

  syncWant();
}

function initSort(form) {
  const select = form.querySelector('select');
  if (!select) {
    return;
  }
  form.classList.add('is-enhanced');
  select.addEventListener('change', () => form.submit());
}

export default function initRoDemands() {
  document.querySelectorAll('[data-ro-demand-budget]').forEach(initBudget);
  document.querySelectorAll('[data-ro-demand-sort]').forEach(initSort);
}
